import * as Constant from "../config/Configuration";

const firebaseAuth = Constant.getFirebaseAuth();
const ref = Constant.getFirebaseDatabase();
export function auth(email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw);
}

export function logout() {
  return firebaseAuth().signOut();
}

export function login(email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw);
}

export function resetPassword(email) {
  return firebaseAuth().sendPasswordResetEmail(email);
}
export function checkRefresh() {
  return firebaseAuth().onAuthStateChanged(function(user) {
    if (user) {
      // User is signed in.
    } else {
      // No user is signed in.
    }
  });
}

export function saveUser(user) {
  return ref
    .child(`users/${user.uid}/info`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => user);
}



// WEBPACK FOOTER //
// ./src/common/helpers/auth.js